module.exports = __webpack_public_path__ + "img/02.d4db5ea2.jpg";